export default "__VITE_ASSET__CqXbfBlm__"